<template>
    <div class="pt">
        <h2 class="title">{{'protocol.active_protocols' | trans }}</h2>
        <assigned-protocol-list :clientId="clientId" :onlyList="onlyList"></assigned-protocol-list>

        <h2 class="title mt-4">{{'bids.bids_for_protocols' | trans }}</h2>
        <bids-list :userId="clientId"></bids-list>
    </div>

</template>

<script>

  import AssignedProtocolList from '../../user/client/components/AssignedProtocolList';
  import BidsList from '@/modules/bids/components/BidsList';
  import Auth from '../../../common/auth/Manager';

  export default {
    name: 'availableProtocol',

    data() {
      return {
        clientId: null,
        onlyList: true,
      };
    },

    components: {
      AssignedProtocolList, BidsList
    },

    async created() {
      this.clientId = Auth.getUserInfo().id;
    },

  };

</script>


// WEBPACK FOOTER //
// src/modules/dashboardParent/components/AvailableProtocolList.vue